import useCurrentStore from '../hooks/useCurrentStore';
import useLoginState from '../hooks/useLoginState';
import notEmpty from '../util/notEmpty';
import useCategory from './useCategory';

const useIsStocklistEnabled = () => {
    const isLoggedIn = useLoginState();
    const { categoryAncestryIds } = useCategory();
    const { stockListEnabledCategories } = useCurrentStore();

    if (!isLoggedIn) {
        return false;
    }

    return categoryAncestryIds
        .filter(notEmpty)
        .some(id => stockListEnabledCategories.includes(id));
};

export default useIsStocklistEnabled;
